import storage from "redux-persist/lib/storage";
import {persistReducer} from "redux-persist";
import {actionTypes} from "./actions";

const initialAuthState = {
  user: undefined,
  authToken: undefined
};

export const reducer = persistReducer(
  {
    storage,
    key: "pl-fs-auth",
    whitelist: ["user", "authToken"],
  },
  (state = initialAuthState, action) => {
    switch (action.type) {
      case actionTypes.Login: {
        const {authToken} = action.payload;
        return {authToken, user: undefined};
      }

      case actionTypes.Register: {
        const {authToken} = action.payload;
        return {authToken, user: undefined};
      }

      case actionTypes.EditMyInfo: {
        const {user} = action.payload;
        return {...state, user: {...state.user, ...user}};
      }

      case actionTypes.RefreshToken: {
        const {authToken} = action.payload;
        return {...state, authToken};
      }

      case actionTypes.UserLoaded: {
        const {user} = action.payload;
        return {...state, user};
      }

      case actionTypes.Logout: {
        // TODO: Change this code. Actions in reducer aren't allowed.
        return initialAuthState;
      }

      default: {
        return state;
      }
    }
  }
);
